var _radialGradient, _clipPath, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1870 1870",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 78,
    cy: 337,
    r: 1854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1815 319l-160 280-45 80h-108l-138 261a441 441 0 01-283 514l-146 265-145-265-15-5a442 442 0 01-269-510L369 679H261l-46-80L55 319h460l75 149 4 2 1-2a340 340 0 01678 0l-2 2-1-2 85-149h460z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M1530 589l-43 90h122l6-10 45-80h-131zm-1192 0H210l51 90h121l-44-90z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M1815 319l-160 280h-112l-179 341-429 779-429-780-179-340H215L55 319h460l75 149 244 445 100 183 96-183 240-445 85-149"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.6 329h-460L55 319h460l5.6 10zm834.4-10l-5.5 10h459.8l5.7-10h-460z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M1615.4 668.8l-5.8 10.2H1501l-137.3 260.5L935 1719 506.3 939.3 369.3 679H260.6l-5.6-10h114.3l5.3 10 131.7 250.3L935 1709l428.7-779.5 137.4-260.7"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105 1039a170 170 0 11-340 0 170 170 0 01340 0zm-20-520a150 150 0 11-300 0 150 150 0 01300 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M1364 940c-23-98-77-182-152-243a340 340 0 10-615-229 339 339 0 0061 229 439 439 0 00-152 242 437 437 0 00-11 100c0 186 116 346 280 410a441 441 0 00160 30 439 439 0 00429-539zM935 379a140 140 0 110 280 140 140 0 010-280zm0 820c-88 0-160-72-160-160a160 160 0 01258-126 159 159 0 0162 126 160 160 0 01-160 160z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1275 499v5c-2.8-185.5-154-335-340-335S597.7 318.5 595 504v-5c0-187.8 152.2-340 340-340s340 152.2 340 340zM654 700.5C557 781 495 902.8 495 1039v5c1.5-136.2 65-257.5 163.4-337.2l4.6-3.7-4.6-6-4.4 4zm562 0l-4.4-3.7-4.6 6.3 4.6 4c98.5 80 162 201 163.4 337v-5c0-136-62-258-159-338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M1375 1034v5c0 243-197 440-440 440s-440-197-440-440v-5c2.7 240.7 198.7 435 440 435s437.3-194.3 440-435zM595 494v5a338 338 0 0068 204c1.6-1 3.2-2.4 5-3.6A338.8 338.8 0 01595 494zm680 0a338.57 338.57 0 01-73 205.4c1.8 1.2 3.4 2.5 5 3.7 42.7-56 68-127 68-204v-5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1815 319l-160 280-45 80h-109l-137 261a441 441 0 01-283 514l-146 265-145-265-15-5a442 442 0 01-269-510L369 679H261l-46-80L55 319h460l75 149 4 2 1-2a340 340 0 01678 0l-2 2-1-2 85-149h460z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV8);
export default __webpack_public_path__ + "static/media/v8.6a3c6baeec6f7a96594ed2e100f60880.svg";
export { ForwardRef as ReactComponent };